// Creates sticky live chat component functionality

export default class Chatlink {

    constructor() {
        this._$el = $(document.querySelectorAll('[data-chatlink]'));

        if(this._$el.length > 0) {
             this._init();
        }
    }

    set isActive (val) {
        this._isActive = val;

        if (val && !this._$el.hasClass('is-active') ) {
            this._$el.addClass('is-active');
            $("#livechat-start").attr("data-value","close-chat");
        }
        if (!val && this._$el.hasClass('is-active') ) {
            this._$el.removeClass('is-active');
            $("#livechat-start").attr("data-value","open-chat");
        }
    }

    get isActive () {
        return this._isActive;
    }

    set isVisible (val) {
        this._isVisible = val;
        if (val && !this._$el.hasClass('is-visible') ) {
            this._$el.addClass('is-visible');
        }
        if (!val && this._$el.hasClass('is-visible') ) {
            this._$el.removeClass('is-visible');
        }
    }

    get isVisible () {
        return this._isVisible;
    }

    set isDesktop (val) {
        if ( val == this._isDesktop ) return false;
        this._isDesktop = val;
        if (val) {
            this._$btnClose.on('click', this.__close);
            this._$el.on('mouseover', this.__mouseOver);
            this._$el.on('mouseout', this.__mouseOut);
            this._$el.on('mouseleave', this.__mouseLeave);
        }
        else
        {
            this._$btnClose.off('click', this.__close);
            this._$el.off('mouseover', this.__mouseOver);
            this._$el.off('mouseout', this.__mouseOut);
            this._$el.off('mouseleave', this.__mouseLeave);
        }
    }

    get isDesktop () {
        return this._isDesktop;
    }

    // public function to close live chat
    close () {
        this.isActive = false;
    }


    _init() {


        this._$toggle = $('.chatlink__toggle', this._$el);
        this._$btnClose = $('.btn-close', this._$el);

        this._isActive = false;
        this._isVisible = false;
        this._activePosY = 20;
        this._int1 = 0;
        this._int2 = 0;


        this.__toggle = this._toggle.bind(this);

        this.__close = this._close.bind(this);
        this.__mouseOver = this._mouseOver.bind(this);
        this.__mouseLeave = this._mouseLeave.bind(this);

        this._$btnClose.on('click', this.__close);

        this._$toggle.on('click', this.__toggle);

    }


    _mouseOver (e) {
       clearTimeout(this._int2);
       this._mouseWithin = true;
    }


    _mouseLeave (e) {
        if (this.isActive ) {
            clearTimeout(this._int2);
            this._int2 = setTimeout( this.__close, 1000);
        }
    }

    _close (e) {
        if(e) e.preventDefault();
        this.close();
        return false;
    }

   _toggle(e) {
        e.preventDefault();
        clearTimeout(this._int2);
        this.isActive = this._isActive ? false : true;
        return false;
    }
}
